import { get, post } from './base'

const productApi = {
  subscriptionDetail() {
    return get('api/product/subscription_detail')
  },

  getNewPlans(currentPaddleId) {
    return post('api/product/new_plans', { currentPaddleId })
  },

  changePlan({ billImmediately = true, newPaddleId = '', subscriptionId = '' }) {
    return post('api/product/change_plan', {
      billImmediately,
      newPaddleId,
      subscriptionId,
    })
  },

  pausePlan({ useTime, cancelReasonList, subscriptionId }) {
    return post('api/product/cancel_plan', {
      useTime,
      cancelReasonList,
      subscriptionId,
      isPause: true,
    })
  },

  cancelPlan({ password, reason, subscriptionId, isPause = false }) {
    return post('api/product/cancel_plan', {
      isPause,
      password,
      reason,
      subscriptionId,
    })
  },

  restartPlan({ subscriptionId }) {
    return post('api/product/restart_plan', {
      subscriptionId,
    })
  },

  // 用户已经在paddle删除订阅 但plan 还没有过期, 可以重新调用paddle绑卡恢复
  resumePlan({ subscriptionId }) {
    return post('api/product/resume_plan', {
      subscriptionId,
    })
  },
}

export default productApi
